/* eslint-disable-next-line */
import { useQuill } from 'react-quilljs';
import { useEffect, useState } from 'react';
import Delta from 'quill-delta';
import 'quill/dist/quill.snow.css';

export interface RichTextEditorProps {
  id: string;
  formik: any;
  value: any;
}

export function RichTextEditor({ formik, value, id }: RichTextEditorProps) {
  const [isRichTextEditorSet, setIsRichTextEditorSet] = useState(false);
  const { quill, quillRef } = useQuill();

  const { setFieldValue } = formik;

  useEffect(() => {
    if (quill && formik && value && !isRichTextEditorSet) {
      quill.setContents((value as Delta) || {});
      setIsRichTextEditorSet(true);
    }
  }, [quill, formik, value]);

  useEffect(() => {
    if (quill) {
      quill.on('text-change', (delta, oldDelta, source) => {
        setFieldValue(id, JSON.parse(JSON.stringify(quill.getContents())));
      });
    }
  }, [quill]);

  return <div ref={quillRef} className="h-[500px]" />;
}

export default RichTextEditor;
